import { Injectable } from '@angular/core';
import { faqResponse } from './models/faq.model';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Apollo, gql, Query } from 'apollo-angular';
import { DocumentNode } from 'graphql';

@Injectable({
  providedIn: 'root',
})
export class FaqsService extends Query<faqResponse> {
  document: DocumentNode = gql`
    query Faqs {
      faqs {
        _id
        createdAt
        updatedAt
        handle
        title
        order
        isVisible
        articles {
          handle
          title
          description
          order
          isVisible
          tags
          instructions {
            mobile {
              steps
              videoURL
            }
            desktop {
              steps
              videoURL
            }
          }
        }
      }
    }
  `;

  faqs: faqResponse;
  constructor(
    apollo: Apollo,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    super(apollo);
  }

  getFaqsData(): Observable<faqResponse> {
    return of(this.faqs);
  }

  fetchFaqs(): Observable<faqResponse> {
    return this.apollo
      .watchQuery({
        query: this.document,
        errorPolicy: 'all',
      })
      .valueChanges.pipe(
        map((res) => {
          if (!res.data) {
            this.snackBar.open(`Error ${res.errors[0]['message']}`, null, {
              duration: 3300,
              panelClass: ['blue-snackbar'],
            });
            this.router.navigate(['home']);
            return;
          }
          const faqData = res.data as faqResponse;
          // Sort both HelpGroups and their articles by order (ascending)
          const sortedFaqs: faqResponse = {
            faqs: [...faqData.faqs]
              .sort((a, b) => a.order - b.order) // Sort HelpGroups by order (asc)
              .map((helpGroup) => ({
                ...helpGroup,
                articles: [...helpGroup.articles].sort(
                  (a, b) => a.order - b.order
                ), // Sort articles by order (asc)
              })),
          };

          this.faqs = sortedFaqs;
          return sortedFaqs;
        }),
        shareReplay(1)
      );
  }
}
